import { render, staticRenderFns } from "./storyofchina.vue?vue&type=template&id=964a8592&scoped=true"
import script from "./storyofchina.vue?vue&type=script&lang=js"
export * from "./storyofchina.vue?vue&type=script&lang=js"
import style0 from "./storyofchina.vue?vue&type=style&index=0&id=964a8592&prod&scoped=true&lang=scss"
import style1 from "./storyofchina.vue?vue&type=style&index=1&id=964a8592&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964a8592",
  null
  
)

export default component.exports